<style>
    [v-cloak] {
        display: none;
    }

    .v-application--wrap {
        background-color: #e1e1e1;
    }

    .v-application--wrap {
        background-color: #e1e1e1;
    }
</style>

    <template>
        <v-container>

            <!--v-if="isLoggedIn">-->
            <v-row align="center"  fill-height fluid class="mt-5">
                <v-col cols="6" class="fill-height"   v-for="(module, index) in customerModules" :key="index" v-if="customerModules">
                    <v-card min-height="300" class="d-flex flex-column align-center justify-center" height="100%">

                        <v-btn icon :to="{name:module.routerLink, path: module.routerLink, query: {modulekey: module.moduleKey } }">
                             <v-icon x-large>{{module.routerIcon}}</v-icon>
                        <span class="ml-2">{{module.routerText}}</span>
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>
            </v-container>
    </template>

    <script>
        export default {
            name: 'Home',

            data: () => ({
                  CustomerStyle: ''
            }),
            mounted() {
                // eslint-disable-line no-debugger
                this.CustomerStyle = this.$store.getters.user.currentCustomer.styles
                debugger  // eslint-disable-line no-debugger
            },
            computed: {
                isLoggedIn: function () { return this.$store.getters.user.isAuthenticated },
                customerModules: function () { return this.$store.getters.user.customerModules },
            customerInfo: function () { return this.$store.getters.user.currentCustomer },
            customerStyles: function () { return this.$store.getters.user.currentCustomer.cssName }
            }

        }
    </script>
